import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { TablePermissions } from './components/table/TablePermissions';
import { BannerInfoPermissions } from './components/BannerInfoPermissions';
import { PageLayout } from 'components/generics/PageLayout';
import { hasPemissions } from 'commons/utils';

export const Permissions = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const [canCreate, setCanCreate] = useState(false);

  useEffect(() => {
    canCheckCanCreate();
  }, []);

  const canCheckCanCreate = async () => {
    const havePermissions = await hasPemissions('modulo.manager', 'modulo.manager.permisos', 'create');
    setCanCreate(havePermissions);
  };



  return (
    <PageLayout
        title="Gestión de Permisos"
        mainModule="Manager"
        icon="AdminPanelSettings"
        infoAlert="Administra los permisos asignables a clientes o empresas"
        actionButtons={
          canCreate ? (
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => navigate('/manager/permisos/crear')}
            >
              Nuevo Permiso
            </Button>
          ) : undefined
        }
    >
      <TablePermissions />
      <BannerInfoPermissions />
    </PageLayout>
  );
};
